import React, { Component } from 'react';
import { changeColorTint } from '../../../styles/utils';
import moment from 'moment';
import { convertToLocalTime } from '../../../utils/timeUtils';

class CanvasserLogListItem extends Component {
  render() {
    let { data, focused, id } = this.props;

    return (
      <div
        className={`CanvasserLogListItem side-menu-list-obj ${focused && 'focused'}`}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        id={id}
        onClick={this.props.onTitleClick}
      >
        {/*inner wrapper to generate side color border*/}
        <div className="list-obj-inner-wrapper" style={{ borderLeftColor: data.color }}>
          <div className="obj-title" onClick={this.props.onTitleClick}>
            {convertToLocalTime(moment(data.time)).format('hh:mm')}
          </div>
          {(!data.longitude || !data.latitude || data.bad_loc_on_last_update) && (
            <div className={'obj-data'} style={{ color: 'red' }}>
              <i className="fas fa-exclamation-triangle"></i> Bad Location Update
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CanvasserLogListItem;
